import React, { FC } from 'react'
import Upload from 'rc-upload'
import Box from '@mui/material/Box'
import { IconButton } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import CreateIcon from '@mui/icons-material/Create'
import api from '@app/api'
import { User } from '@app/types/user'
import { useAppDispatch } from '@app/hooks/useAppDispatch'
import { useTypedSelector } from '@app/hooks/useTypedSelector'
import { ReactComponent as FotoIcon } from '@app/assets/clinic/foto.svg'
import { ReactComponent as FileIcon } from '@app/assets/clinic/file.svg'
import AppFormControl from '@app/components/AppForm/AppFormControl'
import { selectSelectedCoach } from '@app/store/reducers/coaches/selectors'
import { useDefaultComponentTools } from '@app/hooks/useDefaultComponentTools'
import { ReactComponent as FileSucssesIcon } from '@app/assets/clinic/file_done.svg'
import {
	setNewAva,
	setNewCv,
} from '@app/store/reducers/clinicManagement/newUser/actions'
import {
	selectNewUserAva,
	selectNewUserCV,
} from '@app/store/reducers/clinicManagement/newUser/selectors'
import useNewUserForm from './useNewUserForm'

const NewUserFilesItems: FC = () => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [loading, saveButtonDisabled, formMethods, onSubmit] = useNewUserForm(
		undefined,
		undefined,
		true
	)
	const saveFile = formMethods.handleSubmit(onSubmit)
	const user: User = useTypedSelector(selectSelectedCoach)

	const { alert } = useDefaultComponentTools(true)
	const dispatch = useAppDispatch()
	const cv = useTypedSelector(selectNewUserCV)
	const ava = useTypedSelector(selectNewUserAva)
	const getRandomText = (): string => {
		let password = ''
		const possible =
			'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
		for (let i = 0; i < 6; i++)
			password += possible.charAt(
				Math.floor(Math.random() * possible.length)
			)
		return password
	}
	const getUploadAvatar = async (avatar: any): Promise<void> => {
		const fd = new FormData()
		fd.append('file', avatar.file, getRandomText() + '_image')
		try {
			const img = await api.upload.uploadFile(fd)
			dispatch(setNewAva(img.data.result.Location))
			if (user._id) {
				saveFile()
			}
		} catch (e: any) {
			'message' in e && e.message && alert.error(e.message)
		}
	}

	const beforeUploadAvatar = (file: any): any => {
		const isPicture =
			file.type === 'image/jpeg' ||
			file.type === 'image/png' ||
			file.type === 'image/svg+xml'
		if (!isPicture) {
			alert.error('You can only upload JPG/PNG/SVG file!')
		}
		const isLt1M = file.size / 1024 / 1024 < 1
		if (!isLt1M) {
			alert.error('Image must smaller than 1MB!')
		}
		return isPicture && isLt1M
	}

	const getUploadCV = async (action: any): Promise<void> => {
		const fd = new FormData()
		fd.append('file', action.file, getRandomText() + '_file')
		try {
			const file = await api.upload.uploadFile(fd)
			dispatch(setNewCv(file.data.result.Location))
			if (user._id) {
				saveFile()
			}
		} catch (e: any) {
			'message' in e && e.message && alert.error(e.message)
		}
	}

	const getDownloadFile = (): any => {
		window.open(user?.personal?.cvUrl)
	}

	return (
		<Box display={'flex'}>
			<AppFormControl sx={{ mr: 8, width: 'fit-content' }}>
				<Upload
					customRequest={getUploadAvatar}
					beforeUpload={beforeUploadAvatar}
				>
					<Box
						sx={{
							border: 'solid 1px #dcddde',
							padding: '20px',
							height: 69,
							width: 69,
							borderRadius: '50%',
							position: 'relative',
							backgroundImage: `url(${
								user?.personal?.imageUrl || ava
							})`,

							backgroundPosition: 'center',
							backgroundSize: 'cover',
						}}
					>
						{!ava && !user?.personal?.imageUrl && <FotoIcon />}
						<Box
							sx={{
								position: 'absolute',
								top: 20,
								right: -10,
							}}
						>
							<IconButton
								color='primary'
								aria-label='upload picture'
								component='span'
								style={{
									height: 22,
									width: 22,
									border: 'solid 1px #cdcdd8',
									background: '#ffff',
									borderRadius: '50%',
								}}
							>
								<AddIcon sx={{ height: 16, width: 16 }} />
							</IconButton>
						</Box>
					</Box>
				</Upload>
			</AppFormControl>

			<AppFormControl sx={{ mr: 12, width: 'fit-content' }}>
				<Box
					sx={{
						border: 'solid 1px #dcddde',
						height: 69,
						width: 69,
						borderRadius: '50%',
						position: 'relative',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					{!cv && !user?.personal?.cvUrl ? (
						<FileIcon />
					) : (
						<FileSucssesIcon onClick={getDownloadFile} />
					)}
					<Box
						sx={{
							position: 'absolute',
							top: 20,
							right: -10,
						}}
					>
						<Upload customRequest={getUploadCV}>
							<IconButton
								color='primary'
								aria-label='upload picture'
								component='span'
								style={{
									height: 22,
									width: 22,
									border: 'solid 1px #cdcdd8',
									background: '#ffff',
									borderRadius: '50%',
								}}
							>
								<CreateIcon sx={{ height: 12, width: 12 }} />
							</IconButton>
						</Upload>
					</Box>
				</Box>
			</AppFormControl>
		</Box>
	)
}

export default NewUserFilesItems
